import { changeStatusBarTextColor } from "@ht/utils/src/native/methods";

class DarkMode {
  private static instance: DarkMode;
  private _isDarkMode: boolean;
  get isDarkMode() {
    return this._isDarkMode;
  }

  constructor() {
    this._isDarkMode =
      window.navigator.userAgent.toLowerCase().indexOf("isdarkmode") !== -1;
    if (this.isDarkMode) this.enable();
  }

  static getInstance(): DarkMode {
    if (!DarkMode.instance) {
      DarkMode.instance = new DarkMode();
    }
    return DarkMode.instance;
  }

  enable() {
    this._isDarkMode = true;
    document.body.classList.add("dark-mode");
    // changeStatusBarTextColor(1);
  }

  disable() {
    this._isDarkMode = false;
    document.body.classList.remove("dark-mode");
    changeStatusBarTextColor(0);
  }

  statusBarBlackText() {
    // 单纯改变状态栏字体颜色为黑色
    changeStatusBarTextColor(0);
  }

  statusBarWhiteText() {
    // 单纯改变状态栏字体颜色为白色
    changeStatusBarTextColor(1);
  }
}

export const useDarkMode = () => {
  return DarkMode.getInstance();
};
